<template>
  <div class="domains-wrap">
    <el-radio-group
      v-if="isDesktop"
      v-model="useWhiteList"
      class="desktop"
      :disabled="disabled"
      @update:modelValue="update"
    >
      <el-radio-button :key="true" :value="true">
        Only listed {{ title.toLowerCase() }}
      </el-radio-button>
      <el-radio-button :key="false" :value="false">
        Exclude listed {{ title.toLowerCase() }}
      </el-radio-button>
    </el-radio-group>
    <el-select
      v-else
      v-model="useWhiteList"
      :disabled="disabled"
      @update:modelValue="update"
    >
      <el-option
        :key="true"
        :label="`Only listed ${title.toLowerCase()}`"
        :value="true"
      >
        Only listed {{ title.toLowerCase() }}
      </el-option>
      <el-option
        :key="false"
        :label="`Exclude listed ${title.toLowerCase()}`"
        :value="false"
      >
        Exclude listed {{ title.toLowerCase() }}
      </el-option>
    </el-select>
    <br />
    <TextAreaWithArray
      v-if="useWhiteList"
      v-model="whiteLists"
      :rows="4"
      @update:modelValue="updateList"
    />
    <TextAreaWithArray
      v-else
      v-model="blackLists"
      :rows="4"
      @update:modelValue="updateList"
    />
    <p class="hint">
      {{ hint }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import useResize from '@/hooks/useResize'
import TextAreaWithArray from '@/components/TextAreaWithArray.vue'

export default defineComponent({
  name: 'WhiteListsSelector',
  components: {
    TextAreaWithArray
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    blackList: {
      type: Array,
      default: () => []
    },
    whiteList: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const update = (newValue: any) => {
      useWhiteList.value = newValue
      context.emit('update', {
        useWhiteList: useWhiteList.value,
        whiteList: whiteLists.value,
        blackList: blackLists.value,
        type: props.type
      })
    }

    const updateList = () => {
      context.emit('update', {
        useWhiteList: useWhiteList.value,
        whiteList: whiteLists.value,
        blackList: blackLists.value,
        type: props.type
      })
    }

    const { isDesktop } = useResize()

    const useWhiteList = ref(props.modelValue)
    const whiteLists = ref(props.whiteList)
    const blackLists = ref(props.blackList)

    watch(
      (_: any) => props.modelValue,
      (val: any) => {
        useWhiteList.value = val
      }
    )
    watch(
      (_: any) => props.whiteList,
      (val: any) => {
        whiteLists.value = val
      }
    )

    return {
      update,
      useWhiteList,
      isDesktop,
      whiteLists,
      blackLists,
      updateList
    }
  }
})
</script>
<style lang="scss" scoped>
.domains-wrap {
  margin: 13px 5px 5px 5px;

  .el-textarea {
    margin-top: 10px;
    vertical-align: top;
  }

  .hint {
    line-height: 1.2;
    color: var(--el-text-color-secondary);
  }
}
.el-select {
  width: 100%;
}
</style>
